/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { classifyReactionEvents } from '../fn/notification/classify-reaction-events';
import { ClassifyReactionEvents$Params } from '../fn/notification/classify-reaction-events';
import { ReactionsClassificationResponse } from '../models/reactions-classification-response';
import { triggerAllPushNotifications } from '../fn/notification/trigger-all-push-notifications';
import { TriggerAllPushNotifications$Params } from '../fn/notification/trigger-all-push-notifications';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `classifyReactionEvents()` */
  static readonly ClassifyReactionEventsPath = '/api/notifications/reactions/classify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `classifyReactionEvents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  classifyReactionEvents$Response(params: ClassifyReactionEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<ReactionsClassificationResponse>> {
    return classifyReactionEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `classifyReactionEvents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  classifyReactionEvents(params: ClassifyReactionEvents$Params, context?: HttpContext): Observable<ReactionsClassificationResponse> {
    return this.classifyReactionEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReactionsClassificationResponse>): ReactionsClassificationResponse => r.body)
    );
  }

  /** Path part for operation `triggerAllPushNotifications()` */
  static readonly TriggerAllPushNotificationsPath = '/api/notifications/test/{userId}/trigger-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerAllPushNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerAllPushNotifications$Response(params: TriggerAllPushNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return triggerAllPushNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerAllPushNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerAllPushNotifications(params: TriggerAllPushNotifications$Params, context?: HttpContext): Observable<void> {
    return this.triggerAllPushNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
